<section class="m-3">
  <h1 class="my-3">Manage CDS for {{ agencyName }}</h1>
  <p-messages key="oriMergeMessage" [closable]="true"></p-messages>
  <div class="card mb-3">
    <section class="m-3">
      <h2 class="h6 fw-bold font-size-sm">
        Indicate if agency has required MOU/CDS addendum:
      </h2>
      <form [formGroup]="mouForm">
        <div class="form-group">
          <div class="form-check">
            <label class="form-check-label" for="IsMOU"><input #mouChbx id="IsMOU" class="form-check-input" type="checkbox" formControlName="MOU" value="" (change)="mouChbx.checked ? mouForm.get('CDS').enable() : mouForm.get('CDS').disable() "> MOU</label>
          </div>
          <div class="form-check">
            <label class="form-check-label" for="IsCDS"><input #cdsChbx id="IsCDS" class="form-check-input" type="checkbox" formControlName="CDS" value="" (change)="updateCDS(cdsChbx.checked)"> CDS</label> 
          </div>
        </div>
      </form>
    </section>
  </div>
  <div class="mb-3">
    <ness-agency-cds-assign-approver-form [agency]="selectedAgency" (onUpdate)="onCDSApproverUpdate($event)" [optOutEvents]="optOutSubject.asObservable()"></ness-agency-cds-assign-approver-form>
  </div>
  <div class="mb-3">
    <section class="m-3">
      <div class="form-check">
        <label class="form-check-label" for="UserAssert"><input #userAssertChbx id="UserAssert" class="form-check-input me-1 fw-bold" type="checkbox" (change)="userAssertChbx.checked && mouChbx.checked ? saveBtn.disabled = false : saveBtn.disabled = true ">I Understand</label>
      </div>
      <p class="fw-bold font-size-sm">
        You should only check the CDS box indicating the agency wants to participate if the agency has both an MOU and a CDS addendum ratified and on file.
      </p>
      <p class="fw-bold font-size-sm">
        If an agency no longer wants to participate in CDS, remove the CDS Approver, uncheck the CDS box, check the I Understand box, then click Save. This will reset any CDS agreements the agency’s CDS Approver has pending/approved with other agencies.
      </p>
    </section>
  </div>
  <div>
    <button #saveBtn type="button" class="btn btn-active m-3" [disabled]="!userAssertChbx.checked || !mouChbx.checked " (click)="saveAgency()">Save</button>
    <button type="button" (click)="closeForm()" class="btn btn-active mx-3">Cancel</button>
  </div>
</section>
